export default __webpack_public_path__ + "static/1-fd1715e596d899817faa38eebff56cb2.png";